import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { rem, Spacer } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../constants';
import AutosaveActivityCard from './AutosaveActivityCard';
import PendingAutosaveActivityCard from './PendingAutosaveActivityCard';
import UpcomingAutosavePaymentCard from './UpcomingAutosavePaymentCard';
const AutosaveActivityRowItem = ({ activity }) => {
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [activity.isLastInSection && styles.lastItem, activity.isFirstInSection && styles.firstItem], [activity.isLastInSection, activity.isFirstInSection, styles.lastItem, styles.firstItem]);
    if ('sectionTitle' in activity) {
        if (activity.id === 'Pending') {
            return (<>
          <Spacer h={24}/>
          <SectionHeader horizontalMargins>{activity.sectionTitle}</SectionHeader>
        </>);
        }
        return (<SectionHeader horizontalMargins largeVerticalMargins>
        {activity.sectionTitle}
      </SectionHeader>);
    }
    if ('skipped' in activity) {
        return <UpcomingAutosavePaymentCard upcomingPayment={activity}/>;
    }
    if (activity.status === 'PENDING') {
        return <PendingAutosaveActivityCard noMarginTop={false} activity={activity}/>;
    }
    return (<View style={[styles.rowItem, borderStyles]}>
      <AutosaveActivityCard activity={activity} btnStyles={borderStyles}/>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    rowItem: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        // On web the card is padded by 8 and each row by 8, so the hover highlight sits inside the card
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && { paddingTop: rem(8) }),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && { paddingBottom: rem(8) }),
    },
}));
export default memo(AutosaveActivityRowItem);
